/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useState, useLayoutEffect } from 'react';
import { useLeftSidebarState } from '@jira/platform__controllers-layout/src/controllers/layout-controller/consumers/left-sidebar-controller/index.tsx';

const TIMEOUT = 500;

export const useIsFullyExpanded = (): boolean => {
	const [ready, setReady] = useState(false);
	const { isCollapsed } = useLeftSidebarState();

	useLayoutEffect(() => {
		const timeoutId = setTimeout(() => {
			setReady(!isCollapsed);
		}, TIMEOUT);
		return () => clearTimeout(timeoutId);
	}, [isCollapsed]);

	return ready && !isCollapsed;
};
